import { render, staticRenderFns } from "./PrintDocumentNew.vue?vue&type=template&id=c3811d72&"
import script from "./PrintDocumentNew.vue?vue&type=script&lang=js&"
export * from "./PrintDocumentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports